import { Component, ViewEncapsulation } from '@angular/core'
import { Meta, Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'

@Component({
  selector: 'flowaccount-platform-businesses',
  templateUrl: './platform-businesses.component.html',
  styleUrl: './platform-businesses.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PlatformBusinessesComponent {
  protected langChangeSubscription: Subscription
  constructor(
    private readonly seoService: SEOService,
    private readonly titleService: Title,
    public translate: TranslateService,
    private meta: Meta,
  ) {
    this.setMeta()
    this.langChangeSubscription = translate.onLangChange.subscribe((res) => {
      this.setMeta()
      const setContent = res.lang === 'th' ? 'index' : 'noindex'
      this.meta.updateTag({ name: 'robots', content: setContent })
      this.setMeta()
    })
  }
  private setMeta() {
    const metaTitle = this.translate.instant('metaTitle-platform-businesses')
    const metaDescription = this.translate.instant('metaDescription-platform-businesses')
    this.titleService.setTitle(metaTitle)
    this.seoService.createCanonicalURL(metaDescription)

    this.seoService.createOg(
      'https://flowaccountcdn.com/new_landing/image/platform-businesses/become-our-partner/our-integrations_og_image.jpg',
      metaTitle,
      metaDescription,
    )
  }
  ngOnDestroy() {
    this.langChangeSubscription?.unsubscribe()
  }
}
